import {useColorThemeType, useShadow} from '@buncha/appStyles/hooks/theme';

import {Box} from '../../../../../src/components/core/view';
import BuyerReplacementSuggestions from '../buyerReplacementSuggestions';
import DropItemFooter from '../dropItemFooter';
import If from '../../../../../src/components/conditional/If';
import React from 'react';
import SearchResults from './SearchResults';
import {StyleSheet} from 'react-native';
import {useItemReplacementContext} from '../../../../../src/itemDetails/hooks/itemReplacement';

interface ReplacementSuggestionsProps {
  catalogItemId: number;
  category: string;
  searchQuery: string;
  storeId: number;
  subCategory: string;
  isUPCMode?: boolean;
  orderItemId?: number;
  orderId?: number;
  runId?: number;
  quantity?: number;
  isMeijerStore?: boolean;
}

const ReplacementSuggestions: React.FC<ReplacementSuggestionsProps> = props => {
  const {state} = useItemReplacementContext();
  const theme = useColorThemeType();
  const shadow = useShadow('2');
  const subOptions = state?.item?.substitutionOptions || [];

  return (
    <Box
      style={[
        styles.parentBox,
        styles.bodyContainer,
        {
          backgroundColor: theme?.background?.white?.[100],
        },
        shadow,
      ]}>
      <If condition={subOptions.length || props?.isMeijerStore}>
        <BuyerReplacementSuggestions
          hasSubstituteAdded={subOptions?.length > 0}
        />
      </If>
      <If condition={!subOptions.length}>
        <SearchResults
          catalogItemId={props?.catalogItemId}
          category={props?.category}
          searchQuery={props?.searchQuery}
          storeId={props?.storeId}
          subCategory={props?.subCategory}
          isUPCMode={props?.isUPCMode ?? false}
          orderItemId={props?.orderItemId}
          orderId={props?.orderId}
          runId={props?.runId}
          quantity={props?.quantity}
        />
      </If>
      <If condition={!props?.isMeijerStore}>
        <DropItemFooter
          runId={props.runId}
          orderId={props.orderId}
          orderItemId={props.orderItemId ?? 0}
          showCustomItemCTA
        />
      </If>
    </Box>
  );
};
export default ReplacementSuggestions;
const styles = StyleSheet.create({
  parentBox: {
    marginBottom: 0,
    flex: 1,
  },
  bodyContainer: {
    paddingVertical: 15,
    paddingHorizontal: 10,
    marginHorizontal: 15,
    borderRadius: 14,
    marginBottom: 10,
  },
  buttonBox: {
    marginTop: 10,
    marginBottom: 10,
    alignSelf: 'center',
    backgroundColor: 'transparent',
  },
  underlinedText: {
    textDecorationLine: 'underline',
  },
});
